import { createRoot } from "react-dom/client";
import './polyfill/console';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main';
import './polyfill/date';
import './index.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-select/dist/react-select.css';

const root = createRoot(document.getElementById('root') || document.createElement('div'));
root.render(<Main />);
